module.exports = __webpack_public_path__ + "images/fbfa62eca19a5b1b3906b8fe25db4e3c-logo.png";